module.exports = __webpack_public_path__ + "media/images/front/premium_lp/point01/th_06-402f39c880a7b1389474b46164c297c2.jpg";